<h2 class="fw:regular c:blue-700 m-8:t m-16:b md:m-48:t md:m-24:b">Versicherte Personen</h2>
<div class="widget-list">
    @for (insurant of insurants(); track insurant.id) {
        <app-portal-collapsible
            [title]="insurant | fullName"
            [subtitle]="insurant.role"
            icon="person"
        >
            <dl class="grid-container vertical-gutter-lg">
                <app-portal-widget-details
                    class="g-12"
                    heading="Geburtsdatum"
                    [detail]="insurant.dateOfBirth"
                ></app-portal-widget-details></dl
        ></app-portal-collapsible>
    }
</div>
